import FormErrorAlert from '@sophocles/components/FormErrorAlert/FormErrorAlert';

export default FormErrorAlert;
